/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function () {
  // Add custom code below this line
  // Mobile Gallery variables
  let mobileGallerySwiper = null;
  let mobileGalleryInitialized = false;

  if (document.querySelector('[data-product-json]')) {
    // Flag to track if the page has finished initial load
    let initialLoadComplete = false;

    document.addEventListener('theme:variant:change', (event) => {

      const variant = event.detail.variant;
      if (!variant) return;

      // Retrieve product JSON from the page.
      const productJsonEl = document.querySelector('[data-product-json]');
      let productOptions = [];
      if (productJsonEl) {
        try {
          const productData = JSON.parse(productJsonEl.innerHTML);
          productOptions = productData.options || [];
        } catch (e) {
          console.error('Error parsing product JSON:', e);
        }
      }


      // Find the index of the "Color" option.
      const colorIndex = productOptions.indexOf('Color');

      // Initialize selectedColorHandle
      let selectedColorHandle = '';

      if (colorIndex !== -1) {
        // Get the selected color value and convert to handle.
        const selectedColorValue = variant.options[colorIndex];
        selectedColorHandle = selectedColorValue.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      } else {
        console.warn('No "Color" option found. Will display all images.');
        // We'll continue execution to show all images
      }

      /*=== Rebuild Main Product Slides by Removing and Reinserting ===*/
      // Flag to track if we're showing all slides due to no color match
      let showingAllSlides = false;

      const firstSlide = document.querySelector('.product__slide');
      if (firstSlide && firstSlide.parentNode && window.originalProductSlides) {
        const slidesContainer = firstSlide.parentNode;
        let matchingSlides = [];

        // Only filter slides if we have a color variant
        if (colorIndex !== -1) {
          matchingSlides = window.originalProductSlides.filter((slide) => {
            const imageHandle = slide.getAttribute('data-alt-handle') || '';
            // Use a more precise matching to avoid partial matches
            return isExactColorMatch(imageHandle, selectedColorHandle);
          });
        }

        // If no matching slides, use all original slides
        const slidesToUse = matchingSlides.length > 0 ? matchingSlides : window.originalProductSlides;
        showingAllSlides = matchingSlides.length === 0;

        slidesContainer.innerHTML = '';

        // Append each slide back into the container.
        slidesToUse.forEach((slide) => {
          slide.style.transition = "opacity 0.5s ease";
          slide.style.display = "block";
          slide.style.opacity = "0";
          slidesContainer.appendChild(slide);
          // Force a reflow before starting the fade-in.
          void slide.offsetWidth;
          slide.style.opacity = "1";
        });

        // Update mobile gallery with the same filtered slides
        updateMobileGallery(slidesToUse);
      }

      /*=== Update Mobile Thumbs Slider === */
      const thumbsHolder = document.querySelector('product-thumbs .product__thumbs__holder');
      if (thumbsHolder && window.originalProductThumbs) {
        // Filter the stored mobile thumbs based on the selected color handle
        const originalThumbsCopy = window.originalProductThumbs.slice(); // or: [...window.originalProductThumbs]

        // Filter the copy based on the selected color handle.
        let matchingThumbs = [];

        // Only filter thumbs if we have a color variant
        if (colorIndex !== -1) {
          matchingThumbs = originalThumbsCopy.filter((thumb) => {
            const thumbHandle = thumb.getAttribute('data-alt-handle') || '';
            return isExactColorMatch(thumbHandle, selectedColorHandle);
          });
        }

        // If no matching thumbs, use all original thumbs
        const thumbsToUse = matchingThumbs.length > 0 ? matchingThumbs : originalThumbsCopy;

        // Clear the container
        thumbsHolder.innerHTML = '';

        // Append each thumb back into the container with a fade-in effect
        thumbsToUse.forEach((thumb, index) => {
          thumb.style.transition = "opacity 0.5s ease";
          thumb.style.display = "inline-block";
          thumb.style.opacity = "0";
          thumbsHolder.appendChild(thumb);
          // Force a reflow before starting the fade-in.
          void thumb.offsetWidth;
          thumb.style.setProperty('opacity', '1', 'important');
          thumb.classList.add('media--active');
          thumb.classList.remove('media--hidden');

          // IMPORTANT CHANGE: Only set is-active on the first thumb for the new variant
          if (index === 0) {
            // Clear the is-active class from all thumbs
            const activeThumb = thumbsHolder.querySelector('.is-active');
            if (activeThumb) activeThumb.classList.remove('is-active');

            // Mark this thumb as active
            thumb.classList.add('is-active');

            // Try to get data-media-id
            let mediaId = thumb.getAttribute('data-media-id');
            if (!mediaId) {
              const link = thumb.querySelector('[data-thumb-link]');
              mediaId = link ? link.getAttribute('data-media-id') : null;
            }

            if (mediaId) {
              // Update which slide is shown in main view
              const oldActiveSlide = document.querySelector('product-images .product__slide.media--active');
              if (oldActiveSlide) {
                oldActiveSlide.classList.remove('media--active');
                oldActiveSlide.classList.add('media--hiding');
              }

              const newActiveSlide = document.querySelector(`product-images .product__slide[data-media-id="${mediaId}"]`);
              if (newActiveSlide) {
                newActiveSlide.classList.remove('media--hiding');
                newActiveSlide.classList.add('media--active');
              }

              // Also update mobile gallery to show the first slide
              if (mobileGallerySwiper) {
                mobileGallerySwiper.slideTo(0, 0);
              }
            }
          }

          // Delay removing the is-loading class to avoid race conditions
          setTimeout(() => {
            const figure = thumb.querySelector('a figure img');
            if (figure) {
              figure.classList.remove('is-loading');
            }
          }, 100); // 100ms delay
        });
      }

      // Reinitialize the <zoom-images> element so it re-scans its children to start PhotoSwiper
      const zoomEl = document.querySelector('zoom-images');
      if (zoomEl) {
        // Deep-clone the element and replace the old one
        const newZoomEl = zoomEl.cloneNode(true);
        zoomEl.parentNode.replaceChild(newZoomEl, zoomEl);
        // console.log('<zoom-images> reinitialized.');
      }

      attachThumbClickHandlers();

      /* Update PhotoSwipe (Lightbox) Thumbs Template */
      const templateEl = document.querySelector('[data-pswp-thumbs-template]');
      if (templateEl && window.originalPswpThumbs) {
        let matchingThumbs = [];

        // Only filter thumbs if we have a color variant
        if (colorIndex !== -1) {
          matchingThumbs = window.originalPswpThumbs.filter((thumb) => {
            const thumbHandle = thumb.getAttribute('data-alt-handle') || '';
            return isExactColorMatch(thumbHandle, selectedColorHandle);
          });
        }

        // If no matching thumbs, use all original thumbs
        const thumbsToUse = matchingThumbs.length > 0 ? matchingThumbs : window.originalPswpThumbs;

        while (templateEl.content.firstChild) {
          templateEl.content.removeChild(templateEl.content.firstChild);
        }

        // Append each thumb back into the template.
        thumbsToUse.forEach((thumb) => {
          thumb.style.transition = "opacity 0.5s ease";
          thumb.style.display = "inline-block";
          thumb.style.opacity = "0"; // start hidden
          templateEl.content.appendChild(thumb);
          // Force a reflow before starting the fade-in.
          void thumb.offsetWidth;
          thumb.style.opacity = "1";
          thumb.classList.add('media--active');
          thumb.classList.remove('media--hidden');
        });
      }

      /*=== Update Main Slider's Active Image for mobile ===*/
      setTimeout(() => {
        // IMPORTANT: Always reset to first slide when variant changes
        const firstSlide = document.querySelector('product-images .product__slide:first-child');
        if (firstSlide) {
          // Set it as active
          firstSlide.classList.add('media--active');
          firstSlide.classList.remove('media--hiding');

          // Remove active class from other slides
          const otherSlides = document.querySelectorAll('product-images .product__slide:not(:first-child)');
          otherSlides.forEach(slide => {
            slide.classList.remove('media--active');
            slide.classList.add('media--hiding');
          });

          // Set the active media in the product-images container
          const mediaId = firstSlide.getAttribute('data-media-id');
          if (mediaId) {
            const productImagesContainer = document.querySelector('product-images');
            if (productImagesContainer) {
              productImagesContainer.setAttribute('data-active-media', mediaId);
            }

            // Also make the corresponding thumb active
            const thumbs = document.querySelectorAll('.product__thumb');
            thumbs.forEach(thumb => {
              thumb.classList.remove('is-active');

              const thumbMediaId = thumb.getAttribute('data-media-id') ||
                (thumb.querySelector('[data-thumb-link]') ?
                  thumb.querySelector('[data-thumb-link]').getAttribute('data-media-id') :
                  null);

              if (thumbMediaId === mediaId) {
                thumb.classList.add('is-active');
              }
            });

            // Reset mobile slider to first slide
            if (mobileGallerySwiper) {
              mobileGallerySwiper.slideTo(0);
            }

            // Dispatch the media select event
            firstSlide.dispatchEvent(new CustomEvent('theme:media:select', {
              bubbles: true,
              detail: { id: mediaId },
            }));
          }
        }
      }, 200);

      // Add new event listener for radio inputs with the native-color class
      document.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"].native-color')) {
          // Get the section name from the data-color-name attribute of the input
          const dataColorName = event.target.getAttribute('data-color-name');
          // Find the color-option-value only within the corresponding section
          const colorOptionValue = document.querySelector(`.section-${dataColorName} .color-option-value`);
          const selectedColor = event.target.value;

            if (colorOptionValue && colorOptionValue.textContent.trim() !== selectedColor) {
              colorOptionValue.textContent = selectedColor;
            }

          // Do nothing if variant is sold out
          const parentContainer = event.target.closest('.variant-thumbnail-wrapper');
          if (parentContainer && parentContainer.classList.contains('variant-thumbnail--sold-out')) {
            return;
          }

          // Find size radio buttons
          const sizeInputs = document.querySelectorAll('input[type="radio"][name*="Size"]');
          let foundAvailableSize = false;

          // Check if there's already a selected and available size
          sizeInputs.forEach(input => {
            if (input.checked && !input.classList.contains('sold-out')) {
              foundAvailableSize = true;
            }
          });

          // If there's already a valid size selected, do nothing else
          if (foundAvailableSize) return;

          // If not, select the first available size
          sizeInputs.forEach(input => {
            if (!foundAvailableSize && !input.classList.contains('sold-out')) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              foundAvailableSize = true;
            }
          });

          // If no size is available, look in the product JSON
          if (!foundAvailableSize) {
            const productJsonEl = document.querySelector('[data-product-json]');
            if (productJsonEl) {
              try {
                const productData = JSON.parse(productJsonEl.innerHTML);

                // Find the first available variant with the selected color
                const availableVariant = productData.variants.find(variant =>
                  variant.available &&
                  variant.options.some(option => option === selectedColor)
                );

                if (availableVariant) {
                  // Find the corresponding size
                  const sizeOption = availableVariant.options.find((option, index) =>
                    productData.options[index].toLowerCase().includes('size')
                  );

                  if (sizeOption) {
                    sizeInputs.forEach(input => {
                      if (input.value === sizeOption) {
                        input.checked = true;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                        foundAvailableSize = true;
                      }
                    });
                  }
                }
              } catch (e) {
                console.error('Error processing product JSON:', e);
              }
            }
          }
        }
      });

    });

    document.addEventListener('DOMContentLoaded', () => {
      // Store the original product slides 
      const firstSlide = document.querySelector('.product__slide');
      if (firstSlide && firstSlide.parentNode) {
        window.originalProductSlides = Array.from(firstSlide.parentNode.children);

        // Initialize mobile gallery with all slides
        initMobileGallery();
        updateMobileGallery(window.originalProductSlides);
      }

      // Store original mobile thumbs
      const mobileThumbs = document.querySelectorAll('product-thumbs .product__thumb');
      if (mobileThumbs.length) {
        window.originalProductThumbs = Array.from(mobileThumbs);
      }

      // Store the original PhotoSwipe thumbs
      const templateEl = document.querySelector('[data-pswp-thumbs-template]');
      if (templateEl) {
        window.originalPswpThumbs = Array.from(templateEl.content.querySelectorAll('.pswp__thumb'));
      }

      /*=== Logic for updating PDP images on load ===*/
      // Retrieve product JSON from the page.
      const productJsonEl = document.querySelector('[data-product-json]');
      if (productJsonEl) {
        try {
          const productData = JSON.parse(productJsonEl.innerHTML);
          let selectedVariant = null;

          // Check if the URL contains an active cariant
          const urlParams = new URLSearchParams(window.location.search);
          const variantIdParam = urlParams.get('variant');

          if (variantIdParam && productData.variants) {
            // Find the variant that matches the provided variant ID.
            selectedVariant = productData.variants.find(variant => variant.id.toString() === variantIdParam);
          }

          // Fallback to the first variant if no match is found.
          if (!selectedVariant && productData.variants) {
            selectedVariant = productData.variants[0];
          }

          if (selectedVariant) {
            // Dispatch the event with the selected variant.
            document.dispatchEvent(new CustomEvent('theme:variant:change', {
              detail: { variant: selectedVariant }
            }));

            // Use a longer delay for initial page load to ensure everything is ready
            setTimeout(() => {
              initialLoadComplete = true;
            }, 500);
          }
        } catch (e) {
          console.error('Error parsing product JSON:', e);
        }
      }
    });
  }

  // Function to properly match color handles without partial matches
  function isExactColorMatch(imageHandle, selectedColorHandle) {
    if (!imageHandle) return false;

    // Standardize the format by replacing underscores or spaces with dashes
    const standardizedHandle = imageHandle.replace(/[_\s]/g, '-');

    // Compare the standardized handle directly with the selected color handle
    return standardizedHandle === selectedColorHandle;
  }

  function attachThumbClickHandlers() {
    const thumbs = document.querySelectorAll('.product__thumb');
    thumbs.forEach((thumb) => {
      // Remove any existing click listener to avoid duplicates
      thumb.removeEventListener('click', handleThumbClick);
      // Attach the new click listener
      thumb.addEventListener('click', handleThumbClick);
    });
  }

  function handleThumbClick(e) {
    e.preventDefault();
    const thumb = e.currentTarget;

    // Try to get data-media-id from the thumb first.
    // If not found, look for it on the child <a> element.
    let mediaId = thumb.getAttribute('data-media-id');
    if (!mediaId) {
      const link = thumb.querySelector('[data-thumb-link]');
      mediaId = link ? link.getAttribute('data-media-id') : null;
    }
    if (!mediaId) return;

    // Update the main <product-images> container:
    const productImagesContainer = document.querySelector('product-images');
    if (productImagesContainer) {
      productImagesContainer.setAttribute('data-active-media', mediaId);
    }

    // Manually update the slides
    const oldActiveSlide = document.querySelector('product-images .product__slide.media--active');
    if (oldActiveSlide) {
      oldActiveSlide.classList.remove('media--active');
      oldActiveSlide.classList.add('media--hiding');
    }
    const newActiveSlide = document.querySelector(`product-images .product__slide[data-media-id="${mediaId}"]`);
    if (newActiveSlide) {
      newActiveSlide.classList.remove('media--hiding');
      newActiveSlide.classList.add('media--active');
    }

    // Update which thumb is active
    const activeThumb = document.querySelector('.product__thumb.is-active');
    if (activeThumb) activeThumb.classList.remove('is-active');
    thumb.classList.add('is-active');

    // Update mobile slider to the corresponding slide
    if (mobileGallerySwiper) {
      const mobileSlides = document.querySelectorAll('.product__mobile-gallery .swiper-slide');
      mobileSlides.forEach((slide, index) => {
        if (slide.getAttribute('data-media-id') === mediaId) {
          mobileGallerySwiper.slideTo(index);
        }
      });
    }
  }

  // Mobile Gallery Functions
  // Initialize the mobile gallery with Swiper and autoplay
  function initMobileGallery() {
    if (typeof Swiper === 'undefined') {
      // Load Swiper dynamically if not already available
      loadSwiperJS();
      return;
    }

    const mobileGalleryContainer = document.querySelector('.product__mobile-gallery .swiper-container');
    if (!mobileGalleryContainer) return;

    // Clean up existing progress bars to avoid duplicates
    const existingProgressContainers = document.querySelectorAll('.product__mobile-gallery .swiper-progress-container');
    existingProgressContainers.forEach(container => {
      container.remove();
    });

    // Create our progress bar directly in the mobile gallery container
    const progressContainer = document.createElement('div');
    progressContainer.className = 'swiper-progress-container';

    const progressBar = document.createElement('div');
    progressBar.className = 'swiper-progress-bar';

    progressContainer.appendChild(progressBar);

    // Append it after the swiper container
    mobileGalleryContainer.parentNode.insertBefore(progressContainer, mobileGalleryContainer.nextSibling);

    // Initialize Swiper with autoplay that pauses on interaction
    mobileGallerySwiper = new Swiper(mobileGalleryContainer, {
      slidesPerView: 1,
      spaceBetween: 10,
      // Autoplay configuration
      autoplay: {
        delay: 3000, // 3 seconds between slides
        disableOnInteraction: true, // Pause on user interaction
        pauseOnMouseEnter: true, // Pause when mouse hovers over the slider
      },
      on: {
        init: function () {
          // Mark the gallery as initialized for CSS targeting
          document.querySelector('.product__mobile-gallery').classList.add('initialized');

          // Set initial progress on first slide
          const progressBar = document.querySelector('.product__mobile-gallery .swiper-progress-bar');
          if (progressBar) {
            if (this.slides.length <= 1) {
              progressBar.style.width = '100%';
            } else {
              // Show slight progress on first slide
              progressBar.style.width = '10%';
            }
          }
        },
        slideChange: function () {
          updateProgressBar(this);
          syncWithMainGallery(this);
        },
        // Resume autoplay when user stops interacting after a short delay
        touchEnd: function () {
          // Give user a moment before resuming autoplay
          setTimeout(() => {
            if (this.autoplay && this.autoplay.paused) {
              this.autoplay.start();
            }
          }, 3000); // Wait 3 seconds before resuming
        }
      }
    });

    // Add event listeners to pause/resume autoplay on user interaction
    mobileGalleryContainer.addEventListener('mouseenter', function () {
      if (mobileGallerySwiper && mobileGallerySwiper.autoplay) {
        mobileGallerySwiper.autoplay.stop();
      }
    });

    mobileGalleryContainer.addEventListener('mouseleave', function () {
      if (mobileGallerySwiper && mobileGallerySwiper.autoplay) {
        // Resume autoplay after mouse leaves
        setTimeout(() => {
          mobileGallerySwiper.autoplay.start();
        }, 1000); // Short delay before resuming
      }
    });

    mobileGalleryInitialized = true;
    return mobileGallerySwiper;
  }

  // Update the progress bar based on the current slide
  function updateProgressBar(swiper) {
    if (!swiper || !swiper.slides || swiper.slides.length === 0) return;

    const progressBar = document.querySelector('.product__mobile-gallery .swiper-progress-bar');
    if (!progressBar) return;

    if (swiper.slides.length <= 1) {
      // If only one slide, show full progress
      progressBar.style.width = '100%';
    } else {
      // Calculate the progress based on current index
      // Start with 10% on first slide and go to 100% on last slide
      const slideCount = swiper.slides.length - 1;
      const minProgress = 10; // Minimum progress (%)

      if (swiper.activeIndex === 0) {
        progressBar.style.width = minProgress + '%';
      } else {
        const additionalProgress = (100 - minProgress) * (swiper.activeIndex / slideCount);
        const totalProgress = minProgress + additionalProgress;
        progressBar.style.width = totalProgress + '%';
      }
    }

    // Add a transition to the progress bar to match autoplay timing
    // This creates a smooth progress effect during autoplay
    if (swiper.autoplay && !swiper.autoplay.paused) {
      progressBar.style.transition = 'width 0.3s ease';
    } else {
      // Faster transition when manually changing slides
      progressBar.style.transition = 'width 0.2s ease';
    }
  }

  // Sync the mobile gallery slide with the main product gallery
  function syncWithMainGallery(swiper) {
    if (!swiper) return;

    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const mediaId = activeSlide.getAttribute('data-media-id');
    if (!mediaId) return;

    // Update desktop gallery to match
    const productImagesContainer = document.querySelector('product-images');
    if (productImagesContainer) {
      productImagesContainer.setAttribute('data-active-media', mediaId);
    }

    // Update active desktop slide
    const oldActiveSlide = document.querySelector('product-images .product__slide.media--active');
    if (oldActiveSlide) {
      oldActiveSlide.classList.remove('media--active');
      oldActiveSlide.classList.add('media--hiding');
    }

    const newActiveSlide = document.querySelector(`product-images .product__slide[data-media-id="${mediaId}"]`);
    if (newActiveSlide) {
      newActiveSlide.classList.remove('media--hiding');
      newActiveSlide.classList.add('media--active');
    }

    // Update active thumb
    const activeThumb = document.querySelector('.product__thumb.is-active');
    if (activeThumb) activeThumb.classList.remove('is-active');

    const newActiveThumb = document.querySelector(`.product__thumb[data-media-id="${mediaId}"]`);
    if (newActiveThumb) {
      newActiveThumb.classList.add('is-active');
    }
  }

  // Load Swiper JS and CSS dynamically
  function loadSwiperJS() {
    // Load CSS
    const swiperCSS = document.createElement('link');
    swiperCSS.rel = 'stylesheet';
    swiperCSS.href = 'https://unpkg.com/swiper@8/swiper-bundle.min.css';
    document.head.appendChild(swiperCSS);

    // Load JS
    const swiperScript = document.createElement('script');
    swiperScript.src = 'https://unpkg.com/swiper@8/swiper-bundle.min.js';
    swiperScript.onload = function () {
      initMobileGallery();
    };
    document.head.appendChild(swiperScript);
  }

  // Populate the mobile gallery with product images
  // Function to populate the mobile gallery with product images
  function updateMobileGallery(slidesToUse) {
    const mobileGalleryWrapper = document.querySelector('[data-mobile-gallery-wrapper]');
    if (!mobileGalleryWrapper) return;

    // Clear existing slides
    mobileGalleryWrapper.innerHTML = '';

    // Add slides to mobile gallery
    slidesToUse.forEach((slide) => {
      const slideClone = slide.cloneNode(true);
      const slideImage = slideClone.querySelector('img');

      if (slideImage) {
        const mobileSlide = document.createElement('div');
        mobileSlide.className = 'swiper-slide';

        // Extract data attributes for connecting to variants
        const mediaId = slide.getAttribute('data-media-id');
        const altHandle = slide.getAttribute('data-alt-handle');

        if (mediaId) {
          mobileSlide.setAttribute('data-media-id', mediaId);
        }

        if (altHandle) {
          mobileSlide.setAttribute('data-alt-handle', altHandle);
        }

        // Set image opacity to 0.95 to create the gray effect with black background
        slideImage.style.opacity = '0.95';
        mobileSlide.appendChild(slideImage);
        mobileGalleryWrapper.appendChild(mobileSlide);
      }
    });

    // Update Swiper if it's initialized
    if (mobileGalleryInitialized && mobileGallerySwiper) {
      // Store autoplay state before updating
      const wasAutoplayRunning = mobileGallerySwiper.autoplay &&
        !mobileGallerySwiper.autoplay.paused;

      mobileGallerySwiper.update();
      // Reset to the first slide
      mobileGallerySwiper.slideTo(0, 0);

      // Update the progress bar to match the first slide
      setTimeout(() => {
        updateProgressBar(mobileGallerySwiper);

        // Resume autoplay if it was running before
        if (wasAutoplayRunning && mobileGallerySwiper.autoplay) {
          mobileGallerySwiper.autoplay.start();
        }
      }, 50);
    } else {
      // Initialize the gallery if it hasn't been already
      initMobileGallery();
    }
  }

  // Function to update the discount badge
  function updateDiscountBadge() {
    const priceElements = document.querySelectorAll('[data-product-price]');
    const comparePriceElements = document.querySelectorAll('[data-compare-price]');
    const badgeSavings = document.querySelector('#badge-savings');

    // Determine the correct container based on screen width
    const isMobile = window.innerWidth <= 750;
    const container = isMobile
      ? document.querySelector('.product__block.product__badges.product__media .content-badge-savings')
      : document.querySelector('.product__block.product__badges.product__info .content-badge-savings');

    if (!container) return;

    // Find price elements within the price wrapper
    const priceWrapper = document.querySelector('[data-price-wrapper]');
    if (!priceWrapper) return;

    const activePriceElement = Array.from(priceElements).find(el =>
      priceWrapper.contains(el) && el.textContent.trim() !== ''
    );
    const activeComparePriceElement = Array.from(comparePriceElements).find(el =>
      priceWrapper.contains(el) && el.textContent.trim() !== ''
    );

    // Remove existing badge if there's no compare price
    if (!activeComparePriceElement) {
      if (badgeSavings) {
        badgeSavings.remove();
      }
      return;
    }

    if (activePriceElement && activeComparePriceElement) {
      const price = parseFloat(activePriceElement.textContent.replace(/[^0-9.]/g, ''));
      const comparePrice = parseFloat(activeComparePriceElement.textContent.replace(/[^0-9.]/g, ''));

      if (comparePrice > price) {
        const savings = Math.round(((comparePrice - price) / comparePrice) * 100);

        // Create badge if it doesn't exist
        if (!badgeSavings) {
          const badgeHTML = `
            <div id="badge-savings">
              <span class="box-sale">${savings}% OFF</span> <span class="custom-final-sale">Final Sale</span>
            </div>
          `;
          container.insertAdjacentHTML('afterbegin', badgeHTML);
        } else {
          // Update existing badge
          const boxSale = badgeSavings.querySelector('.box-sale');
          if (boxSale) {
            boxSale.textContent = `${savings}% OFF`;
          }
          badgeSavings.style.display = 'flex';
        }
      } else {
        if (badgeSavings) {
          badgeSavings.remove();
        }
      }
    }
  }

  // Mutation observer for price changes
  function observePriceChanges() {
    const isMobile = window.innerWidth <= 750;
    const container = isMobile
      ? document.querySelector('.product__block.product__head.product__media')
      : document.querySelector('.product__block.product__head.product__info');

    if (!container) return;

    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const target = mutation.target;
          if (target.matches('[data-product-price], [data-compare-price]') ||
            target.querySelector('[data-product-price], [data-compare-price]')) {
            shouldUpdate = true;
          }
        }
      });

      if (shouldUpdate) {
        updateDiscountBadge();
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    updateDiscountBadge();
    observePriceChanges();
  });

  // Add listener for window resize
  window.addEventListener('resize', () => {
    updateDiscountBadge();
    observePriceChanges();
  });

  // Function to handle automatic variant selection when the page loads
  function initializeVariantSelection() {
    // Find all color variant containers
    const variantContainers = document.querySelectorAll('.product-color-section');
    
    variantContainers.forEach(container => {
      // Find the element that shows the selected color
      const colorValueElement = container.querySelector('.color-option-value');
      
      // Only continue if it exists and has a value
      if (colorValueElement && colorValueElement.textContent.trim() !== '') {
        const selectedColor = colorValueElement.textContent.trim();
        
        // Select the correct variant only when the page loads
        const colorInputs = container.querySelectorAll('input[type="radio"]');
        let foundMatch = false;
        
        colorInputs.forEach(input => {
          if (input.value === selectedColor) {
            input.checked = true;
            foundMatch = true;
            
            // Update the 'active' class
            const parentWrapper = input.closest('.variant-thumbnail-wrapper');
            if (parentWrapper) {
              container.querySelectorAll('.variant-thumbnail-wrapper').forEach(wrapper => {
                wrapper.classList.remove('active');
              });
              parentWrapper.classList.add('active');
            }
            // Trigger the change event only once
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        
        // If no exact match, try partial match
        if (!foundMatch) {
          colorInputs.forEach(input => {
            if (input.value.includes(selectedColor) || selectedColor.includes(input.value)) {
              input.checked = true;
              const parentWrapper = input.closest('.variant-thumbnail-wrapper');
              if (parentWrapper) {
                container.querySelectorAll('.variant-thumbnail-wrapper').forEach(wrapper => {
                  wrapper.classList.remove('active');
                });
                parentWrapper.classList.add('active');
              }
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
      }
    });
  }

  // Execute the function when the DOM is fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    initializeVariantSelection();
  });

  // Hide color/specialty sections if all their options are sold out
  function hideEmptyColorSections() {
    document.querySelectorAll('.variant-thumbnails').forEach(thumbnailsContainer => {
      const options = thumbnailsContainer.querySelectorAll('.variant-thumbnail-wrapper');
      if (options.length === 0) return;

      // Check if all options have the 'variant-thumbnail--sold-out' class
      const allSoldOut = Array.from(options).every(opt => opt.classList.contains('variant-thumbnail--sold-out'));

      if (allSoldOut) {
        // Find the ancestor .product-color-section and hide it
        const colorSection = thumbnailsContainer.closest('.product-color-section');
        if (colorSection && !colorSection.classList.contains('product-size-section')) {
          colorSection.style.display = 'none';
        }
      } else {
        // If at least one option is available, show the section
        const colorSection = thumbnailsContainer.closest('.product-color-section');
        if (colorSection) {
          colorSection.style.display = '';
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    hideEmptyColorSections();
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.

})();

